import { http } from './http'
import { Pagination } from './map'
import { IUser } from './users'

export interface IInvite {
  id: string
  price: number
  label: string
  locale: string
  redeemCode: string
  used: boolean
  usedDateTimestamp: number
  generatedTimestamp: number
  user: IUser
  email: string
  ticket: {
    festivalEdition: {
      id: string
      name: string
    }
    category: {
      id: string
      name: string
    }
    ticket: {
      id: string
      name: string
    }
    dubaiOverwritePriceTypeCode: null
  }
  freeRedeem: boolean
  freeCheckin: boolean
  tax: number
  taxType: string
  ticketsUsedOn: [ITicketUsedOn]
}

export interface ITicketUsedOn {
  boughtForId: string
  boughtForName: string
  boughtForPhone: string
  ticketOwner: boolean
}

export interface IInviteBatch {
  id: string
  label: string
  ticket: {
    festivalEdition: {
      id: string
      name: string
    }
    category: {
      id: string
      name: string
    }
    ticket: {
      id: string
      name: string
    }
    dubaiOverwritePriceTypeCode: string
  }
  createdBy: string
  createdTimestamp: number
  zipLink: string
  zipPassword: string
  status: 'COMPLETED' | 'PROCESSING' | 'FAILED' | 'CANCELED'
}

export type InvitesPaginationParams = {
  page?: number
  size?: number
  sortBy?: string
  sortDirection?: string
  startDate?: number
  endDate?: number
  redeemCode?: string | null
  label?: string | null
}

export type DonwloadInvitesPaginationParams = {
  page?: number
  size?: number
  sortBy?: string
  sortDirection?: string
  label?: string | null
}

export interface CreateInvitePayload {
  label: string
  locale: string
  ticketId: string
  price: number
  freeCheckin: boolean
  nrOfInvites: number
  nominated: boolean
  nominateType?: string
  uploadKey?: string
  emails?: string[]
  generateType?: string
  receiverEmail?: string
  dubaiPriceTypeCode?: string
  intownTicketId?: string
  tax?: number
  redeemTaxType?: string
  taxType?: string
}

interface IEmailCsvResponse {
  failedEmails: string[]
  successfullyValidated: number
  uploadKey: string
}

export const getAllInvites = (params?: InvitesPaginationParams) =>
  http.get<Pagination<IInvite>>('/operations/invites', {
    params,
  })

export const getInvite = (id: string) =>
  http.get<IInvite>(`/operations/invites/${id}`)

export const createInvite = (data: CreateInvitePayload) => {
  return http.post('/operations/invites', data)
}

export const uploadCsv = (file: File) => {
  const data = new FormData()
  data.append('csv', file)
  return http.post<IEmailCsvResponse>('/operations/invites/email-upload', data)
}

export const getAllDownloadInvites = (
  params?: DonwloadInvitesPaginationParams,
) =>
  http.get<Pagination<IInviteBatch>>('/operations/invites/batch', {
    params,
  })

export const updateInvite = (
  id: string,
  data: { freeRedeem?: boolean; freeCheckin?: boolean; used?: boolean },
) => http.put(`/operations/invites/${id}`, data)

export const downloadInvitePdf = (id: string) =>
  http.get(`/operations/invites/${id}/pdf`, {
    responseType: 'blob',
  })

export const cancelInviteBatch = (id: string) =>
  http.put(`/operations/invites/batch/${id}/cancel`)

export const cancelInvite = (id: string) =>
  http.put(`/operations/invites/${id}/cancel`)
